export { default, ICON_NAMES } from './Icon';
